export const NONE = 'NONE';
export const LEFT = 'LEFT';
export const RIGHT = 'RIGHT';


/** WEBPACK FOOTER **
 ** ./src/constants/RotationDirection.js
 **/